import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import styled from 'styled-components';

import Layout from '../../DashboardLayout/views/Layout';
import DashboardToolbarBrokerHistory from '../../../components/DashboardToolbarBrokerHistory';
import { shape } from 'prop-types';
import DashboardBrokerHistoryFamilySituation from '../../../components/DashboardBrokerHistoryFamilySituation';
import DashboardBrokerHistoryInsuranceInformation from '../../../components/DashboardBrokerHistoryInsuranceInformation';
import { TopNavigationItems } from '../../../services/context/TopNavigationBarContext';
import {
  setTabItems,
  getHistory,
  setInsurTypes,
} from '../../../services/brokerhistoryService';
import { getNestedObject } from '../../../services/objectService';
import { useTranslation } from 'react-i18next';
import DashboardBrokerHistoryConversationInformation from '../../../components/DashboardBrokerHistoryConversationInformation';

const BrokerHistoryDetailLiability = ({ match, history }) => {
  const { setNavTabs } = useContext(TopNavigationItems);
  const [filteredInsureTypes, setFilteredInsureTypes] = useState([]);
  const [sessionData, setSessionData] = useState({});
  const [extraInfo, setExtraInfo] = useState({});
  const [insuranceInformation, setInsuranceInformation] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    setInsurTypes(match.params.id, setSessionData).then(res => {
      setSessionData(res.sessionData);
      setFilteredInsureTypes(res.filteredData);
      const tmpItems = setTabItems(match.params.id, res.sessionData, t);
      setNavTabs(tmpItems);
    });
  }, []);

  useEffect(() => {
    const { already_insured_with } =
      getNestedObject(sessionData, ['family']) || {};

    const { day, month, year } =
      getNestedObject(sessionData, [
        'family',
        'previous_insurance_start_date',
      ]) || {};

    const date =
      (day || month || year) !== undefined
        ? `${day}/${month}/${year}`
        : undefined;

    setInsuranceInformation({
      insurer: already_insured_with,
      date,
    });
  }, [sessionData]);

  useEffect(() => {
    // safely check if it exists in object
    setExtraInfo(getNestedObject(sessionData, ['family']) || {});
  }, [sessionData]);

  return (
    <>
      <DashboardToolbarBrokerHistory
        onClick={() =>
          getHistory(
            match.params.id,
            filteredInsureTypes,
            history,
            t,
            sessionData,
          )
        }
        dataTestId="dashboard_history_detail_calculate"
        btnText={t('History.goToMarket')}
      />
      <SectionWrapper>
        <DashboardBrokerHistoryConversationInformation
          sessionData={sessionData}
        />
        <DashboardBrokerHistoryFamilySituation
          familySituationData={extraInfo}
        />
        <DashboardBrokerHistoryInsuranceInformation
          insurer={insuranceInformation.insurer}
          date={insuranceInformation.date}
        />
      </SectionWrapper>
    </>
  );
};

const BrokerHistoryDetailLiabilityWrapper = ({ match, history }) => {
  return (
    <StyledLayout>
      <BrokerHistoryDetailLiability match={match} history={history} />
    </StyledLayout>
  );
};

const StyledLayout = styled(Layout)`
  width: 100%;
`;

const SectionWrapper = styled.div`
  margin: 0 auto;
  width: 90%;
`;

BrokerHistoryDetailLiability.propTypes = {
  history: shape().isRequired,
  match: shape(),
};

BrokerHistoryDetailLiabilityWrapper.propTypes = {
  history: shape().isRequired,
  match: shape(),
};

export default withRouter(BrokerHistoryDetailLiabilityWrapper);
